import { getFromLocalStorage } from '@famly/stat_ts-utils_local-storage';
/**
 * Whether every language should be served the base language's translation file instead of its own.
 *
 * Set `famly.baseTranslationsOnly` to `true` in localStorage to turn it on. Cypress does that for
 * every spec that compares a visual-regression snapshot, so a baseline's copy only moves when an
 * engineer edits the base catalogue — in the same pull request as the new baseline — rather than
 * when Crowdin syncs a locale nobody in this repo touched.
 *
 * The key is spelled out again on the Cypress side (`serveBaseTranslations`), which cannot reach
 * these helpers from the runner's window. Renaming it here therefore switches the mechanism off
 * silently — every baseline still matches the locale it was captured in — so this function's test
 * pins the exact string that side writes. Change both together.
 *
 * It is worth knowing by hand too: it shows the source copy for any account, whatever language it
 * is set to, without a development build. The inverse switch, `famly.dontShowBaseTranslations`,
 * only opts a development build out of the base copy it serves en_US accounts by default.
 */
export const baseTranslationsOnly = () => Boolean(getFromLocalStorage('baseTranslationsOnly'));
